import { LucideIcon, Inbox } from 'lucide-react';
import { Card } from './Card';
import { Button } from './Button';

export interface EmptyStateProps {
  icon?: LucideIcon;
  title?: string;
  message?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

export function EmptyState({
  icon: Icon = Inbox,
  title = 'Nenhum dado encontrado',
  message = 'Não há itens para exibir no momento.',
  action,
  className,
}: EmptyStateProps) {
  return (
    <Card className={`text-center py-12 px-8 ${className || ''}`}>
      <Icon className="w-16 h-16 mx-auto mb-4 text-surface-500 opacity-50" />
      <h3 className="text-lg font-semibold text-surface-200 mb-2">{title}</h3>
      <p className="text-surface-400 mb-4 max-w-sm mx-auto">{message}</p>
      {action && (
        <Button onClick={action.onClick} variant="secondary">
          {action.label}
        </Button>
      )}
    </Card>
  );
}

export default EmptyState;
